<template>
  <div id="search-input-container">
    <input type="text" class="modal-search-input" :style="{width:width,height:height}" :value="locationKeyword">
    <ul class="search-result-list" v-show="resulistShow">
      <li class="search-result-item">1234567</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'searchInput',
  props:{
    width:{
      type:String,
      default: '214px'
    },
    height: {
      type: String,
      default: '30px'
    },
    keyword:{
      type: String,
      default: ''
    },
    result: {
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data(){
    return {
      locationKeyword:'',
      resulistShow: false,
      locationResult: {}
    }
  },
  computed:{
    
  },
  mounted(){
    this.initData();
  },
  methods: {
    // initData
    initData() {
      this.locationResult = this.$props.result;
    },
    // keyup
    getParams() {
      let keyword = this.locationKeyword;
      this.$emit('up',keyword);
    }
  }
}
</script>
<style scoped>
  #search-input-container{
    width: fit-content;
    height: fit-content;
    position: relative;
  }

  .modal-search-input {
    border: solid 1px #e5e5e5;
    outline: none;
    text-indent: 16px;
  }

  .search-result-list {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    width: 100%;
    height: fit-content;
    max-height: 200px;
    padding: 5px 0;
    z-index: 9;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0,0,0,.4);
    overflow: auto;
  }

  .search-result-item {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    text-indent: 1em;
  }

  .search-result-item:hover {
    background-color: rgba(125,125,125,.3);
  }
</style>